<template>
  <div>
    <custom-actions show-back :title="isApproval ? '供应商审批' : '供应商详情'">
      <el-form class="form" v-loading='loading' :model="formData" ref="form" label-width="140px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName">
              {{ formData.companyName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业统一信用代码" prop="businessLicense">
              {{ formData.businessLicense }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人姓名" prop="legalName">
              {{ formData.legalName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人身份证号码" prop="legalId">
              {{ formData.legalId }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行开户行" prop="bankAccount">
              {{ formData.bankAccount }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行开户账号" prop="bankNum">
              {{ formData.bankNum }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              {{ formData.contactPerson }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人号码" prop="contactNumber">
              {{ formData.contactNumber }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照" prop="">
              <el-image :src="formData.businessFile" :preview-src-list="[formData.businessFile]"></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="食品经营许可证" prop="">
              <el-image :src="formData.taxCert" :preview-src-list="[formData.taxCert]"></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人身份证头像面" prop="">
              <el-image :src="formData.legalFileUp" :preview-src-list="[formData.legalFileUp]"></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人身份证国徽面" prop="">
              <el-image :src="formData.legalFileDe" :preview-src-list="[formData.legalFileDe]"></el-image>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="审批记录">
              <el-timeline :reverse="true" placement="top">
                <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index"
                  :timestamp="item.ctime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24">
                        审批状态：
                        <el-tag v-if="item.nodeResult == '0'">待审批</el-tag>
                        <el-tag type="success" v-if="item.nodeResult == '1'">审批通过</el-tag>
                        <el-tag type="danger" v-if="item.nodeResult == '2'">审批驳回</el-tag>
                      </el-col>
                      <el-col :span="24">
                        审批节点：{{ item.nodeName || '--' }} </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24" v-if="item.nodeOpinion">
                        审批意见：{{ item.nodeOpinion || '--' }}
                      </el-col>
                    </el-row>

                  </el-card>

                </el-timeline-item>
              </el-timeline>

            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
          <el-button type="primary" v-if="isApproval && formData.nodeRole === userInfo.roleId" @click="showDialog"
            class="global-button">审核</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-dialog title="审批" class="global-dialog" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">

      <div class="dlg-content">
        <el-form class="global-form" v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData2"
          :rules="rules" ref="form2" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="nodeResult" label="审批状态">
                <el-radio-group v-model="formData2.nodeResult">
                  <el-radio label="1">审核通过</el-radio>
                  <el-radio label="2">审核驳回</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="nodeOpinion" label="审批意见">
                <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入审批意见"
                  v-model="formData2.nodeOpinion">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitDlg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {

  name: 'SupplierDetail',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      currentImageIndex: 0,
      formData: {
        companyId: '', // 企业ID
        openId: '', // 注册人openID
        companyName: '', // 公司名称
        companyState: '', // 审批状态1审批中2已通过3已拒绝
        businessLicense: '', // 组织机构代码
        legalName: '', // 法人姓名
        legalId: '', // 法人身份证号码
        bankAccount: '', // 银行开户行
        bankNum: '', // 银行开户账号
        contactPerson: '', // 联系人
        contactNumber: '', // 联系号码
        businessFile: '', // 营业执照(文件)
        legalFileUp: '', // 法人身份证头像面
        legalFileDe: '', // 法人身份证国徽面
        taxCert: '', // 企业纳税证明(文件)
        isDel: '', // 是否删除，1为删除，0为未删除
        ctime: '', // 创建时间
        recordList: [] // 审批记录
      },
      formData2: {
        companyId: '', // 企业ID
        nodeOpinion: '', // 审批意见
        nodeResult: '' // 审批状态0待审批1审批通过2审批驳回
      },
      rules: {
        nodeResult: [
          {
            required: true,
            message: '请选择审批状态'
          }
        ],
        nodeOpinion: [
          {
            required: true,
            message: '请输入审批意见'
          }
        ]
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    companyId() {
      return this.$route.query.companyId
    },
    isApproval() {
      return this.$route.query.isApproval === '1'
    }
  },
  created() {
    if (this.companyId) {
      this.loadDetails()
    }
  },

  methods: {
    loadDetails() {
      this.loading = true
      this.$axios.get(this.$apis.supplier.selectYcCompanyInfoByCompanyId, {
        companyId: this.companyId
      }).then(res => {
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    },
    showDialog() {
      this.dialogVisible = true
      this.formData2.companyId = this.companyId
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.form2.resetFields()
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        this.$axios.post(this.$apis.supplier.approveYcCompanyInfo, this.formData2).then(res => {
          this.handleClose()
          this.loadDetails()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-image {
  width: 130px;
  height: 130px;
}

.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader,
.el-radio-group,
.el-input-number {
  width: 400px;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
